import { sm2 } from 'sm-crypto'
const _0x4a2f = ['0486bf32a76c88eedaec0a52978a2520bd75620b5aceb9661439c36d79f79d07472d63d9828b588ac66dc0c1482f589b4c6868f1252c2c2bc13210aed1755af37e']
const _0x7b3c = ['2aa11ffe0ebacfafce35232ecb024e4eefe08f20615b5fe3022c69de5b2fe831']
const getPublicKey = () => {
    return _0x4a2f[0]
}
const getPrivateKey = () => {
    return _0x7b3c[0]
}
const cipherMode = 0 // 1 - C1C3C2，0 - C1C2C3
export default {
    // 使用C1C3C2模式（参数1表示C1C3C2）
    encryptText (plaintext) {
        if (!plaintext) return;
        let res = JSON.stringify(plaintext)
        try {
            const publicKey = getPublicKey()
            const cipherHex = '04' + sm2.doEncrypt(res, publicKey, cipherMode);
            return cipherHex
        } catch (error) {
            console.error('encryptTextFiled:', error);
        }
    },
    decryptText (ciphertext) {
        if (!ciphertext) return;
        try {
            let cipherHex = ciphertext
            cipherHex = cipherHex.slice(2);
            const privateKey = getPrivateKey()
            const decrypted = sm2.doDecrypt(cipherHex, privateKey, cipherMode);
            return decrypted ? JSON.parse(decrypted) : decrypted;
        } catch (error) {
            console.error('decryptTextFiled:', error);
        }
    },
}


// WEBPACK FOOTER //
// ./src/common/sm2.js